// Build-time feature flags.
//
// Create React App inlines `process.env.REACT_APP_*` at build time, so a flag
// is fixed for the life of a bundle: flipping one means a rebuild. In Amplify
// that is a branch environment variable plus a redeploy, not a runtime toggle.
//
// Flags are opt-in — anything other than the exact string "true" leaves the
// feature off — so a build that has never heard of a flag keeps it hidden.

// Onboarding: prospect administration, contract drafting and signing, station
// setup and go-live, and the onboarding dashboards. Every screen in the group
// depends on account endpoints that are not on the production account service
// yet, so the menu group and its routes stay hidden until this is turned on.
// Without the flag an admin would see seven entries that can only report an
// error. Set REACT_APP_ONBOARDING_ENABLED=true on a branch to show them.
export const isOnboardingEnabled =
  process.env.REACT_APP_ONBOARDING_ENABLED === "true";
